import { useState, useEffect, useMemo } from "react";

import { Home } from "lucide-react";

import { useNavigate } from "react-router-dom";

import { MaxWidthWrapper } from "@/shared/ui/MaxWidthWrapper";
import { Button } from "@/shared/ui/button";

import { MobileDrawer } from "./MobileDrawer";
import { useSessionStore } from "@/entities/session";
import { getNavRoutes } from "../SideBar/model/nav-routes";
import { NotificationsButton } from "@/features/NotificationsButton/NotificationButton";
import { useIsClanLeader } from "@/entities/clans/api";

export const MobileDock = () => {
  const navigate = useNavigate();

  const { user } = useSessionStore();
  const isClanLeader = useIsClanLeader();

  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const generateMobileDockLinks = useMemo(() => {
    const routes = getNavRoutes(
      user?.role || "",
      user?.permissions ?? [],
      isClanLeader ?? false,
    );

    const dockRoutes = user?.role !== "manager" ? routes.slice(1, 3) : routes;
    return dockRoutes.map(({ link, label, icon }) => {
      if (label === "Скоро") return;
      return (
        <Button
          key={label}
          variant="secondary"
          onClick={() => navigate(link)}
          className="flex-grow"
        >
          {icon}
        </Button>
      );
    });
  }, [navigate, user?.role]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <MaxWidthWrapper
      className={`fixed bottom-0 left-0 right-0 z-[10] mx-auto h-16 w-full rounded-t-xl bg-bgColor shadow-[rgba(10,10,10,0.1)_0px_-5px_10px] transition-transform duration-300 ease-in-out ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <nav className="flex h-full items-center justify-between gap-2">
        {user?.role !== "manager" ? (
          <Button
            variant={"secondary"}
            className="flex-grow"
            onClick={() => navigate("/")}
          >
            <Home />
          </Button>
        ) : null}
        {generateMobileDockLinks}
        <NotificationsButton
          variant={"secondary"}
          isMobile
          className="flex-grow"
        />
        <MobileDrawer user={user} />
      </nav>
    </MaxWidthWrapper>
  );
};
